<template>
  <div>
    <hr-dialog
      width="80%"
      :visible.sync="visible"
      :title="title"
      :handleClose="handleClose"
      operatorModel="view"
    >
      <template slot="body">
        <div>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
            @selection-change="selectionChange"
          >
          </avue-crud>
        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import { getCarOnlinePayLogByBillId } from '@/api/v4ward/car/tempcarbill';

export default {
  components: {},
  props: {
    tempCarBillId: '',
    spaceId: '',
    visible: false,
  },
  data() {
    return {
      data: [],
      title: '支付明细',
      option: {
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        refreshBtn: false,
        viewBtn: false,
        searchBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '支付单号',
            prop: 'tradeNo',
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            width: 90,
          },
          {
            label: '应收金额',
            prop: 'orderAmount',
            align: 'right',
            width: 70,
          },
          {
            label: '实收金额',
            prop: 'payMoney',
            align: 'right',
            width: 70,
          },
          {
            label: '是否付款',
            prop: 'payStatus',
            type: 'select',
            width: 85,
            dicData: [
              {
                label: '未付款',
                value: 1,
              },
              {
                label: '已付款',
                value: 2,
              },
              {
                label: '放弃付款',
                value: 3,
              },
            ],
          },
          {
            label: '付款时间',
            prop: 'payTime',
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            width: 90,
            dicData: [
              {
                label: '微信',
                value: '1',
              },
              {
                label: '支付宝',
                value: '2',
              },
              {
                label: '中国农业银行',
                value: '3',
              },
              {
                label: '现金',
                value: '4',
              },
              {
                label: '免费开闸',
                value: '5',
              },
              {
                label: '其它',
                value: '6',
              },
              {
                label: '余额抵扣',
                value: '7',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch: {
    visible() {
      this.$emit('update:visible', this.visible);
    },
  },
  created() {},
  methods: {
    handleClose() {},
    onLoad() {
      this.loading = true;
      getCarOnlinePayLogByBillId(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          { tempCarBillId: this.tempCarBillId, spaceId: this.spaceId }
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style></style>
